import { render, staticRenderFns } from "./InProgressCoursesModal.vue?vue&type=template&id=1f5c43f0&"
import script from "./InProgressCoursesModal.vue?vue&type=script&lang=js&"
export * from "./InProgressCoursesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports